module.exports = __webpack_public_path__ + "img/2x.828ce95.jpg";